module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-21 at 12.21.15.696d7e3c.png";